(() => {
  const timerKey = 'glowraid-browsing-session-v2';
  function initTimer(bar) {
    if (bar.dataset.ready) return;
    bar.dataset.ready = 'true';
    const clock = bar.querySelector('[data-gr-time]');
    if (!clock) return;
    const duration = Math.max(1, Number(bar.dataset.minutes) || 20) * 60000;
    const now = Date.now();
    let deadline = now + duration;
    try {
      const saved = Number(sessionStorage.getItem(timerKey));
      if (Number.isFinite(saved) && saved > now && saved <= now + duration) deadline = saved;
      else sessionStorage.setItem(timerKey, String(deadline));
    } catch (_) {}
    function tick() {
      const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      clock.textContent = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
      if (seconds === 0) clearInterval(interval);
    }
    const interval = setInterval(tick, 1000);
    tick();
  }
  function formatMoney(picker, cents) {
    return new Intl.NumberFormat(picker.dataset.locale || 'en', { style: 'currency', currency: picker.dataset.currency || 'USD' }).format(cents / 100);
  }
  function updateBundle(picker) {
    const selected = picker.querySelector('[data-gr-quantity]:checked');
    if (!selected) return;
    const card = selected.closest('[data-gr-tier]');
    picker.querySelectorAll('[data-gr-tier]').forEach(tier => tier.classList.toggle('is-selected', tier === card));
    card.querySelector('[data-gr-addon-slot]').appendChild(picker.querySelector('[data-gr-addons]'));
    const extras = [...picker.querySelectorAll('[data-gr-addon]:checked')].reduce((sum, input) => sum + Number(input.dataset.price), 0);
    const total = Number(selected.dataset.total) + extras;
    picker.querySelector('[data-gr-summary]').textContent = `${selected.value} ${Number(selected.value) === 1 ? 'set' : 'sets'}${extras ? ' + selected extras' : ''} · ${formatMoney(picker, total)} total`;
    const section = picker.closest('.shopify-section') || document;
    const text = section.querySelector('[data-gr-buy] [data-gr-button-label]');
    if (text) text.textContent = `GET MY GLOWRAID — ${formatMoney(picker, total)}`;
  }
  function init() {
    document.querySelectorAll('[data-gr-flash]').forEach(initTimer);
    document.querySelectorAll('[data-gr-bundles]').forEach(picker => {
      if (picker.dataset.ready) return;
      picker.dataset.ready = 'true';
      picker.addEventListener('change', () => updateBundle(picker));
      updateBundle(picker);
    });
  }
  // Preserve native cart rendering while removing orphaned add-ons and capping them at one.
  const nativeFetch = window.fetch?.bind(window);
  if (nativeFetch) window.fetch = async (input, options) => {
    const response = await nativeFetch(input, options);
    const url = String(typeof input === 'string' ? input : input?.url || '');
    if (!response.ok || !/\/cart\/(?:change|update)(?:\.js)?(?:\?|$)/.test(url)) return response;
    const config = document.querySelector('[data-gr-cart-config]');
    if (!config) return response;
    try {
      const cart = await response.clone().json();
      if (!Array.isArray(cart.items)) return response;
      const main = Number(config.dataset.mainVariant);
      const addonIds = config.dataset.addonVariants.split(',').map(Number).filter(Boolean);
      const hasMain = cart.items.some(item => Number(item.variant_id) === main);
      const updates = {};
      const seen = new Set();
      cart.items.forEach(item => {
        if (!addonIds.includes(Number(item.variant_id))) return;
        const target = hasMain && !seen.has(Number(item.variant_id)) ? 1 : 0;
        seen.add(Number(item.variant_id));
        if (item.quantity !== target) updates[item.key] = target;
      });
      if (!Object.keys(updates).length) return response;
      const root = window.Shopify?.routes?.root || '/';
      const cleaned = await nativeFetch(`${root}cart/update.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates, sections: Object.keys(cart.sections || {}), sections_url: location.pathname })
      });
      if (!cleaned.ok) return response;
      const data = await cleaned.json();
      return new Response(JSON.stringify({ ...cart, ...data }), { status: 200, headers: { 'Content-Type': 'application/json' } });
    } catch (_) { return response; }
  };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('click', async (event) => {
    const more = event.target.closest?.('[data-gr-review-more]');
    if (more) {
      const mockup = more.closest('[data-gr-review-mockup]');
      mockup?.querySelectorAll('.gr-review[hidden]').forEach(card => { card.hidden = false; });
      more.setAttribute('aria-expanded', 'true');
      more.hidden = true;
      return;
    }
    const button = event.target.closest?.('[data-gr-buy]');
    if (!button) return;
    const form = button.closest('form');
    if (!form) return;
    const component = button.closest('product-form[data-gr-variant-id]');
    if (!component || !form.action.includes('/cart/add')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.grPending === 'true') return;
    const variantId = Number(component.dataset.grVariantId);
    if (!Number.isSafeInteger(variantId) || variantId <= 0) return;
    const section = button.closest('.shopify-section') || document;
    const picker = section.querySelector('[data-gr-bundles]');
    const selected = picker?.querySelector('[data-gr-quantity]:checked');
    const quantity = Number(selected?.value || 1);
    if (![1, 2, 3].includes(quantity) || selected?.disabled) return;
    let error = form.querySelector('[data-gr-purchase-error]');
    if (!error) {
      error = document.createElement('p');
      error.dataset.grPurchaseError = '';
      error.setAttribute('role', 'alert');
      form.appendChild(error);
    }
    error.hidden = true;
    form.dataset.grPending = 'true';
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    try {
      const root = window.Shopify?.routes?.root || '/';
      const items = [{ id: variantId, quantity }];
      const checkedAddons = [...(picker?.querySelectorAll('[data-gr-addon]:checked') || [])];
      if (checkedAddons.length) {
        const cartResponse = await fetch(`${root}cart.js`, { headers: { 'Accept': 'application/json' } });
        if (!cartResponse.ok) throw new Error('Could not check your cart. Please try again.');
        const cart = await cartResponse.json();
        checkedAddons.forEach(input => {
          const id = Number(input.value);
          if (Number.isSafeInteger(id) && id > 0 && !cart.items.some(item => Number(item.variant_id) === id))
            items.push({ id, quantity: 1, properties: { '_glowraid_addon': 'true' } });
        });
      }
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname })
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || 'Could not add this set. Please try again.');
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(button);
        drawer.renderContents(data);
      } else location.assign(`${root}cart`);
    } catch (failure) {
      error.textContent = failure.message || 'Could not add this set. Please try again.';
      error.hidden = false;
    } finally {
      form.dataset.grPending = 'false';
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
    }
  }, true);
  init();
})();
